import React, {useState, useEffect, useRef} from "react";
import assets from "../assets/imgs";
import CalendarPopup from "./CalendarPopup";

function MyPageHeader({style, headTitle,
  searchTerm, setSearchTerm, dataNumber, handleCategorySelect, selectedCategory, tableTitles, handleSearch}){
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const searchRef = useRef(null);  
  
  
  const handleSearchFocus = () => {
    setIsSearchFocused(true);
    if (searchRef.current) {
      searchRef.current.focus();
    }
  };

  const handleSearchBlur = () => {
    setIsSearchFocused(false);
  };
  
  return(
    <div style={styles.header}>
      <div style={styles.titleSection}>
        <h1 className="font-body1-semibold" style={styles.title}>{headTitle}</h1>
        <p className="font-body3-medium">총 {dataNumber} 개</p>
      </div>       
      <div style={styles.searchSection}>
        <div style={styles.searchLowSection}>
          <CategoryFilterButton 
            onSelectCategory={handleCategorySelect} 
            selectedCategory={selectedCategory}
            categories = {tableTitles}/>
          <div style={styles.searchInput} onClick={handleSearchFocus}>
            {!isSearchFocused && (
              <assets.icons.search
                style={{
                  color: "var(--grayscale_cool_70)",
                }}
              />
            )}
            <input
              ref={searchRef}  
              type="text"
              placeholder={isSearchFocused ? "" : "원하는 메뉴를 검색해보세요."}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value) }
              onFocus={handleSearchFocus} // 포커스 상태 관리
              onBlur={handleSearchBlur} // 포커스 해제 시 상태 초기화
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              className="font-body3-semibold" style={{color:"var(--text-color_50)", border: "none", outline: "none", flex: "1"}}
            />
          </div>
        </div>          
        <button onClick={handleSearch} style={styles.searchButton} className="font-body3-medium">검색</button>
      </div> 
    </div>
  );
}

function CommuteHeader({style, 
  searchTerm, setSearchTerm, handleSearch}){

  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const searchRef = useRef(null);  
    
  const handleSearchFocus = () => {
    setIsSearchFocused(true);
    if (searchRef.current) {
      searchRef.current.focus();
    }
  };

  const handleSearchBlur = () => {
    setIsSearchFocused(false);
  };

  return(
    <div style={styles.header}>
      <div style={{...styles.searchSection, gap: "20px", flex: 1}}>
        <div style={{...styles.searchLowSection, flex: 1}}>
          <div style={{...styles.searchInput, backgroundColor: "var(--grayscale-cool_20)", flex: 1}} onClick={handleSearchFocus}>
            {!isSearchFocused && (
              <assets.icons.search
                style={{
                  color: "var(--grayscale_cool_70)",
                }}
              />
            )}
            <input
              ref={searchRef}  
              type="text"
              placeholder={isSearchFocused ? "" : "원하는 메뉴를 검색해보세요."}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value) }
              onFocus={handleSearchFocus} // 포커스 상태 관리
              onBlur={handleSearchBlur} // 포커스 해제 시 상태 초기화
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              className="font-body3-semibold" 
              style={{color:"var(--text-color_50)", border: "none", outline: "none", flex: "1", backgroundColor: "var(--grayscale-cool_20)"
                }}
            />
          </div>
        </div>          
        <button onClick={handleSearch} style={{...styles.searchButton, display: "flex", alignItems: "center", justifyContent: "center",
          gap: "8px", width: "134px", height: "49px",
          cursor :"pointer" 
        }}
          className="font-body3-medium">
          검색
          <assets.icons.search style={{color: "white"}}/>
        </button>
      </div> 
    </div>
  );
};

function PerformanceHeader({style, headTitle, tableTitles,
  searchTerm, setSearchTerm,
  handleCategorySelect, selectedCategory, 
  handleDateSelect, selectedDate, dataNumber, handleSearch}){
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const searchRef = useRef(null);  
  
  const handleSearchFocus = () => {
    setIsSearchFocused(true);
    if (searchRef.current) {
      searchRef.current.focus();
    }
  };

  const handleSearchBlur = () => {
    setIsSearchFocused(false);
  };
  
  return(
    <div style={styles.header}>
      <div style={styles.titleSection}>
        <h1 className="font-body1-semibold" style={styles.title}>{headTitle}</h1>
        <p className="font-body3-medium">총 {dataNumber} 개</p>
      </div>       
      <div style={styles.searchSection}>
        <div style={styles.searchLowSection}>
          <DateFilterButton onSelectDate={handleDateSelect} selectedDate={selectedDate}/>
          <CategoryFilterButton 
            onSelectCategory={handleCategorySelect} 
            selectedCategory={selectedCategory}
            categories = {tableTitles}/>
          <div style={styles.searchInput} onClick={handleSearchFocus}>
            {!isSearchFocused && (
              <assets.icons.search
                style={{
                  color: "var(--grayscale_cool_70)",
                }}
              />
            )}
            <input
              ref={searchRef}  
              type="text"
              placeholder={isSearchFocused ? "" : "원하는 메뉴를 검색해보세요."}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value) }
              onFocus={handleSearchFocus} // 포커스 상태 관리
              onBlur={handleSearchBlur} // 포커스 해제 시 상태 초기화
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              className="font-body3-semibold" style={{color:"var(--text-color_50)", border: "none", outline: "none", flex: "1"}}
            />
          </div>
        </div>          
        <button onClick={handleSearch} style={styles.searchButton} className="font-body3-medium">검색</button>
      </div> 
    </div>
  );
}

function BoardHeader({style, headTitle, tableTitles,
  searchTerm, setSearchTerm,
  boardTypeList, selectedBoardType, handleBoardTypeSelect,
  dataNumber, handleSearch, handleCategorySelect, selectedCategory
}){
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const searchRef = useRef(null);
  const handleSearchFocus = () => {
    setIsSearchFocused(true);
    if (searchRef.current) {
      searchRef.current.focus();
    }
  };

  const handleSearchBlur = () => {
    setIsSearchFocused(false);
  };

  return(
    <div style={styles.header}>
      <div style={styles.titleSection}>
        {boardTypeList && boardTypeList.length > 0 ? (
          <div style={styles.titleListSection}>
            {boardTypeList.map((boardType, index) => (
              <h1 key={index} className="font-body1-semibold" 
                style={{...styles.title, 
                  cursor: "pointer",
                  color: (selectedBoardType === boardType.key) ? "var(--grayscale_100)": "var(--grayscale_60)"
                }} 
                onClick={() => handleBoardTypeSelect(boardType.key)}>
                {boardType.titleLabel}
              </h1>
            ))}
          </div>
        ) : (
          <h1 className="font-body1-semibold" style={styles.title}>
            {headTitle}
          </h1>
        )}
        <p className="font-body3-medium">총 {dataNumber} 개</p>
      </div>       
      <div style={styles.searchSection}>
        <div style={styles.searchLowSection}>
          <CategoryFilterButton 
            onSelectCategory={handleCategorySelect} 
            selectedCategory={selectedCategory}
            categories = {tableTitles}/>
          <div style={styles.searchInput} onClick={handleSearchFocus}>
            {!isSearchFocused && (
              <assets.icons.search
                style={{
                  color: "var(--grayscale_cool_70)",
                }}
              />
            )}
            <input
              ref={searchRef}  
              type="text"
              placeholder={isSearchFocused ? "" : "원하는 메뉴를 검색해보세요."}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value) }
              onFocus={handleSearchFocus} // 포커스 상태 관리
              onBlur={handleSearchBlur} // 포커스 해제 시 상태 초기화
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              className="font-body3-semibold" style={{color:"var(--text-color_50)", border: "none", outline: "none", flex: "1"}}
            />
          </div>
        </div>          
        <button onClick={handleSearch} style={styles.searchButton} className="font-body3-medium">검색</button>
      </div> 
    </div>
  );
}


function DateFilterButton({onSelectDate, selectedDate}){
  const [isPopupVisible, setPopupVisible] = useState(false);
  const today = new Date();
  const defaultDate = `${today.getFullYear()}-${today.getMonth() + 1}-01`; // Default to current year
  const buttonRef = useRef();
  const popupRef = useRef(); // Ref for the popup container

  // const togglePopup = () => setPopupVisible(!isPopupVisible);
  const handleDatePickerOpen = (event) => {
    event.stopPropagation();
    popupRef.current = event.target; // 클릭된 DOM 저장
    setPopupVisible(!isPopupVisible);
  };

  const handleDateSelect = (value) => {
    onSelectDate(value);
    setPopupVisible(false);
  };
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     console.log(popupRef.current && !popupRef.current.contains(event.target) && 
  //     !buttonRef.current.contains(event.target));
  //     if (
  //       popupRef.current && 
  //       !popupRef.current.contains(event.target) && 
  //       !buttonRef.current.contains(event.target)
  //     ) {
  //       // setPopupVisible(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  const formatDateToKorean = (dateString) => {
    if (!dateString || typeof dateString !== "string") {
      throw new Error("Invalid date string");
    }
  
    const [year, month] = dateString.split("-");
    
    if (!year || !month) {
      throw new Error("Invalid date format. Expected 'YYYY-MM'");
    }
  
    const formattedYear = year.slice(-2); // 마지막 두 자리만 사용
    const formattedMonth = parseInt(month, 10); // 앞에 '0' 제거
    
    return `${formattedYear}년 ${formattedMonth}월`;
  }

  const selected = (selectedDate !== null);

  return (
    <div style={{ position: "relative" }}>
      <button ref={buttonRef} onClick={(e) => handleDatePickerOpen(e)} style={{
        ...styles.dateFilterButton, 
        borderColor: selected ? "var(--main-blue_50)": "var(--grayscale-cool_50)"}}
        >
        <p className="font-body4-semibold" style={{color: selected ? "var(--main-blue_60" : "var(--text-color_50)" }}>
          {selected ? formatDateToKorean(selectedDate) : '전 기간'}
        </p>
        <img src={selected ? assets.icons.calendar_selected : assets.icons.calendar} 
        style={{width: "16px"}}/>
      </button>
      {isPopupVisible && (
        <CalendarPopup
          selectedDate={selectedDate ?? defaultDate }
          onSelect={(date) => handleDateSelect(date)}
          onClose={() => setPopupVisible(false)}
          limitUnit = {'month'}
          anchorRef={popupRef}
        />
      )}
    </div>
  );
}

function CategoryFilterButton({onSelectCategory, categories, selectedCategory}){
  //selectedCategory는 key로 전달한다.
  const [isPopupVisible, setPopupVisible] = useState(false);
  const buttonRef = useRef();
  const popupRef = useRef(); // Ref for the popup container
  
  const togglePopup = () => setPopupVisible(!isPopupVisible);

  const handleCategorySelect = (key) => {
    
    console.log("Selected Category: ", key); 

    onSelectCategory(key);
    setPopupVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current && 
        !popupRef.current.contains(event.target) && 
        !buttonRef.current.contains(event.target)
      ) {
        setPopupVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const selected = (selectedCategory !== null);

  return (
    <div style={{ position: "relative" }}>
      <button ref={buttonRef} onClick={togglePopup} style={{
        ...styles.categoryFilterButton, 
        borderColor: selected ? "var(--main-blue_50)": "var(--grayscale-cool_50)"}}
        >
        <p className="font-body4-semibold" style={{color: selected ? "var(--main-blue_60" : "var(--text-color_50)" }}>
          {selected ? '분류 :' +  findLabelByKey(categories, selectedCategory) : '분류'}
        </p>
        <assets.icons.sort style={{color: selected ? "var(--main-blue_60)" : "var(--grayscale_60)"}}/>
        {/* <img src={selected ? assets.icons.calendar_selected : assets.icons.calendar} 
        style={{width: "16px"}}/> */}
      </button>
      {isPopupVisible && (
        <div ref={popupRef} style={styles.categoryFilterBox}>
          <ul style={styles.categoryList}>
            {categories
            .filter(category => category.searchable !== false)
            .map((category) => (
              <li
                key={category.key}
                onClick={() => handleCategorySelect(category.key)}
                style={{
                  ...styles.categoryItem,
                  color:
                    selectedCategory === category.key
                      ? "var(--main-blue_60)"
                      : "var(--text-color_50)",
                  fontWeight:
                    selectedCategory === category.key ? "bold" : "normal",
                }}
              >
                <p className="font-body2-semibold" style={{
                  flex: "1",
                  color : (selectedCategory === category.key) ? "var(--text-color_70)" : "var(--text-color_50)"
                }}>{category.label}</p>
                {(selectedCategory === category.key) ? 
                  <assets.icons.check style={{color: "var(--main-blue_50)"}}/> 
                  : null}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}


const findKeyByLabel = (categories, label) => {
  const found = categories.find((item) => item.label === label);
  return found ? found.key : null; // 값이 없으면 null 반환
};

const findKeyByTitleLabel = (categories, titleLabel) => {
  const found = categories.find((item) => item.titleLabel === titleLabel);
  return found ? found.key : null; // 값이 없으면 null 반환
};

const findLabelByKey = (categories, key) => {
  const found = categories.find((item) => item.key === key);
  return found ? found.label : null; // 값이 없으면 null 반환
};

const filterButton = {
  border: "1px solid var(--grayscale-cool_50)",
  borderRadius: "4px",
  height: "45px",
  display:"flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  padding:"8px 16px",
  backgroundColor: "white",
  cursor: "pointer",
}

const filterBox ={
  position: "absolute",
  boxSizing: "border-box",
  top: "calc(100% + 10px)",
  left: 0,
  background: "white",
  border: "1px solid #ddd",
  borderRadius: "8px",
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
  zIndex: 1000,
}

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    padding: "0px 6px",
  },
  titleSection:{
    display: "flex",
    alignItems: "center",
    gap: "24px"
  },  
  titleListSection:{
    display:"flex",
    gap: "24px"
  },  
  searchSection:{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  searchInput:{
    padding: '12px', width: '370px' , height: "45px", borderRadius: "8px", gap: "10px",
    boxSizing: "border-box", border: "1px solid var(--grayscale-cool_50)", background: "white",
    display: "flex", justifyContent: "flex-start", alignItems: "center", cursor: "text"
  },
  searchButton:{
    borderRadius: "8px", backgroundColor: "var(--primary-crimson_40)", textAlign: "center",
    color: "white", width: "112px", height: "45px", border: "none", cursor:"pointer"
  },
  searchLowSection:{
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  
  // dateFilterButton
  
  dateFilterButton:{
    ...filterButton,
  },

  //categoryFilterButton

  categoryFilterButton:{
    ...filterButton,
  },
  categoryFilterBox:{
    ...filterBox,
  },
  categoryItem:{
    minWidth: "102px",
    padding: "16px 20px 16px 16px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    borderBottom: "1px solid var(--grayscale-cool_20)",
    cursor: "pointer",
  },
};

const TableHeaderSet = {MyPageHeader, CommuteHeader, PerformanceHeader, BoardHeader}

export default TableHeaderSet;